import { render } from "./OneByOneTable.vue?vue&type=template&id=18747418"
import script from "./OneByOneTable.vue?vue&type=script&lang=js"
export * from "./OneByOneTable.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__